// ATB Constants
// It should be part of ATB repo, but for some reason it doesn't work properly.
// Viddhiyartha Panjarethinam said we have to store it on our side until cli team resolves it.
// TODO Wipe out
export const CS_PHONE_NUMERIC = '1-800-289-6229';
export const YOU_SAVED = 'You saved';
export const REGISTRY_FOR = 'Gift Registry for';
export const ATB_PROS_ZONES = ['ATBPage_ZONE_C', 'ATBPage_ZONE_D'];
export const MERCHANT_NAME = 'macys';
